// This hook is now deprecated. Use useCanCreateProject from usePermissions instead.
// Keeping for backward compatibility
import { useCanCreateProject } from './usePermissions';

export const useProjectCreation = () => {
    const projectPermissions = useCanCreateProject();
    
    return {
        currentProjectCount: projectPermissions.currentProjectCount,
        projectLimit: projectPermissions.projectLimit,
        isProjectLimitUnlimited: projectPermissions.isProjectLimitUnlimited,
        isProfileComplete: projectPermissions.isProfileComplete,
        isProjectLimitReached: projectPermissions.isProjectLimitReached,
        isProjectCreationDisabled: !projectPermissions.canCreateProject,
        getProjectCreationTooltip: projectPermissions.getProjectCreationTooltip
    };
};
